import { render, staticRenderFns } from "./BackgroundPrintPreview.vue?vue&type=template&id=2b2729ec&"
import script from "./BackgroundPrintPreview.vue?vue&type=script&lang=ts&"
export * from "./BackgroundPrintPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports